import { useEffect } from 'react';
import { useRouter } from 'next/router';
import useAuth from '@/hooks/useAuth';

/**
 * アクセス状況をトラッキングする
 */
export const AccessTracker = () => {
  const router = useRouter();
  const { isAuthenticated, isRequiredInitialPayment, isRequiredSubscriptionPayment } = useAuth();

  useEffect(() => {
    // 未ログイン状態の場合は処理しない
    if (!isAuthenticated && !isRequiredInitialPayment && !isRequiredSubscriptionPayment) {
      return;
    }

    const handleRouteChange = async () => {
      await fetch('/api/users/access', {
        method: 'POST',
      });
    };

    // その後のページ遷移
    router.events.on('routeChangeComplete', handleRouteChange);

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router, isAuthenticated, isRequiredInitialPayment, isRequiredSubscriptionPayment]);

  return null;
};
